import './MessengerMessagesLoader.css';

interface MessengerMessagesLoaderProps {
  className?: string;
  label?: string;
}

export function MessengerMessagesLoader({
  className,
  label = 'Загрузка сообщений',
}: MessengerMessagesLoaderProps) {
  return (
    <div
      className={['messengerMessagesLoader', className].filter(Boolean).join(' ')}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label}
    >
      <span className="messengerMessagesLoader__spinner" aria-hidden />
    </div>
  );
}
